import { styled, Tab, Tabs, Typography } from '@mui/material';
import React, { SyntheticEvent } from 'react';

export enum ACCOUNT_FAVORITES_TABS {
	FAVORITES = 'FAVORITES',
	FOR_LATER = 'FOR_LATER',
}

interface AccountFavoriteTabsProps {
	currentTab: ACCOUNT_FAVORITES_TABS;
	favoriteCount: number;
	forLaterCount: number;
	onTabChange: (tab: ACCOUNT_FAVORITES_TABS) => void;
}

const StyledTabs = styled(Tabs)(({ theme }) => ({
	'& .MuiTabs-indicator': {
		height: 4,
		backgroundColor: theme.palette.primary.main,
	},
}));

const AccountFavoriteTabText = ({ text, count }: { text: string; count: number }) => (
	<Typography component="span" sx={{ fontSize: 'var(--font-size-md)', fontWeight: 800, color: '#2C2C2C' }}>
		{text}
		<Typography component="span" sx={{ fontSize: 'var(--font-size-md)', color: '#929292' }}>
			{` (${count})`}
		</Typography>
	</Typography>
);

export const AccountFavoriteTabs: React.FC<AccountFavoriteTabsProps> = ({
	currentTab,
	favoriteCount,
	forLaterCount,
	onTabChange,
}) => {
	const handleTabChange = (_event: SyntheticEvent, newValue: ACCOUNT_FAVORITES_TABS) => {
		onTabChange(newValue);
	};

	return (
		<StyledTabs value={currentTab} onChange={handleTabChange}>
			<Tab
				label={<AccountFavoriteTabText text="MIS FAVORITOS" count={favoriteCount} />}
				value={ACCOUNT_FAVORITES_TABS.FAVORITES}
			/>
			<Tab
				label={<AccountFavoriteTabText text="GUARDADOS" count={forLaterCount} />}
				value={ACCOUNT_FAVORITES_TABS.FOR_LATER}
			/>
		</StyledTabs>
	);
};
